import { combineReducers } from "@reduxjs/toolkit";
import channelReducer from "./channel";

const channelsReducer = combineReducers({
    channel: channelReducer,
});

export default channelsReducer;
